import { Injectable } from '@angular/core';
import { MediaUtils } from '../../../utils/media.utils';
import { EditedImageResult } from '../model/edited-image-result.model';

/**
 * Gerencia o cache de imagens editadas e estados dos marcadores
 */
@Injectable()
export class ImageCacheManager {
    public editedImages: EditedImageResult[] = [];
    public markerStatesCache = new Map<number, any>();
    public initialMarkerStatesCache = new Map<number, any>();
    public cacheUpdateIntervals = new Map<number, any>();
    private isRestoringState = false;

    constructor(private _mediaUtils: MediaUtils) {}

    /**
     * Adiciona uma imagem editada à lista de resultados
     */
    addEditedImage(position: number, file: File): void {
        const existingIndex = this.editedImages.findIndex(img => img.position === position);
        const editedImage: EditedImageResult = {
            position,
            file,
            size: this._mediaUtils.getFileSizeInGB(file),
        };

        if (existingIndex >= 0) {
            this.editedImages[existingIndex] = editedImage;
        } else {
            this.editedImages.push(editedImage);
        }
    }

    /**
     * Limpa todas as imagens editadas
     */
    clearEditedImages(): void {
        this.editedImages = [];
    }

    /**
     * Limpa todos os caches
     */
    clearAllCaches(): void {
        this.markerStatesCache.clear();
        this.initialMarkerStatesCache.clear();
        this.cacheUpdateIntervals.forEach(interval => clearInterval(interval));
        this.cacheUpdateIntervals.clear();
    }

    /**
     * Limpa todos os intervalos
     */
    clearAllIntervals(): void {
        this.cacheUpdateIntervals.forEach(interval => clearInterval(interval));
        this.cacheUpdateIntervals.clear();
    }

    /**
     * Define se está restaurando estado
     */
    setIsRestoringState(value: boolean): void {
        this.isRestoringState = value;
    }

    /**
     * Verifica se está restaurando estado
     */
    getIsRestoringState(): boolean {
        return this.isRestoringState;
    }
}
